<template>
    <div :class="['banner', 'banner--prefixed']">
        <div v-if="Boolean(icon)" class="icon">
            <img class="iconsSymbol" :src="icon" />
        </div>

        <p class="banner__content">
            <span class="banner__message">{{ message }}</span
            >&nbsp;<a :href="href">{{ linkText }}</a>
        </p>
    </div>
</template>

<script>
export default {
    name: 'Banner',
    props: {
        message: {
            type: String,
            default: '',
            required: true,
        },
        linkText: {
            type: String,
            default: '',
        },
        href: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            default: null,
        },
    },
}
</script>

<style lang="stylus">
.banner {
    color: $cs-black;
    background-color: $cs-snow;
    width: 60%;
    height: $cs-spaces.sextuple;
    border-radius: 10px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
    padding-left: 30px;

    @media $display-breakpoints.sm-and-down {
        width: 100%;
        height: $cs-spaces.s900;
        padding-left: 40px;
    }

    &__content {
        margin: 0 0 $cs-spaces.half 6px;
        padding-left: 10px;
        padding-right: 10px;
        position: relative;
        font-weight: 500;
    }
    &__message {
        color: $cs-black;
        font-size: 16px;
        font-weight: 500;
    }
    &--prefixed {
        .banner__content {
            margin: 0 0 $cs-spaces.half 0;
        }
    }
    &--large {
        .banner__message {
            font-size: 14px;
            margin: 0;
        }
        width: $cs-spaces.s2000;
        height: $cs-spaces.s2000;
    }

    a {
        color: black;
        text-decoration: none !important;
    }

    .icon {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 80px;
        width: 80px;

        .iconsSymbol {
            position: absolute;
            width: 80px;
            height: 80px;
        }
    }
}
</style>
